import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import MigrationFormModal from '@components/base/Modal/MigrationFormModal/MigrationFormModal';

const BG = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Безплатна миграция в Superhosting',
					text: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-16-24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '',
					subtitle: '',
					description: 'Ако вече притежаваш уебсайт, ние ще се погрижим да го преместим в superhosting.bg – бързо, лесно и в удобно за теб време.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '',
					subtitle: '',
					description: '',
					buttonText: 'стартирай миграция',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: MigrationFormModal,
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Free migration to Superhosting',
					text: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-16-24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '',
					subtitle: '',
					description: 'If you already have a website, we will migrate it to SuperHosting quickly, easily, and at a time convenient for you.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '',
					subtitle: '',
					description: '',
					buttonText: 'start migration',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: MigrationFormModal,
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];